export default {
  appointments                  : [],
  appointmentsAppearance        : 'list', // list, grid
  appointmentsLoading           : false,
  appointmentsHistory           : [],
  appointmentsHistoryAppearance : 'list', // list, grid
  appointmentsHistoryLoading    : false,
}
